import React, { useContext, useEffect, useState } from 'react';
import ABResultHeader from './ABResultHeader';
import ResultAnalytics from './ResultAnalytics';
import ResultInfo from './ResultInfo';
import { computeABTestResult } from '../../services/ABServices';
import { toast } from 'react-toastify';
import TableSkeletonElement from 'Components/GMS/Products/components/TableSkeletonElement';
import { ABContext } from '../../contexts/ABContext';
import NoDataComponent from 'Components/Common/NoDataComponent';

type TABResultPageProps = {
    testId?: string;
}

const ABResultPage = ({ testId }: TABResultPageProps) => {
    const [loading, setLoading] = useState<boolean>(false)

    const abContext = useContext(ABContext);
    const { testData, setTestData } = abContext

    const getTestResult = async () => {
        try {
            if (testId) {
                setLoading(true)
                const res = await computeABTestResult(testId as string)
                if (res?.done) {
                    setTestData(res?.data)
                }
                else toast.info(res?.message)
            }
            else toast.info("test id not found")
        } catch (error) {
            setLoading(false)
        }
        finally { setLoading(false) }
    }

    useEffect(() => {
        getTestResult()
    }, [])

    return (
        loading ?
            <TableSkeletonElement /> :
            [undefined, null].includes(testData) ? <NoDataComponent /> :
        <>
                <ABResultHeader testName={testData?.name ?? ''} testId={testId as string} />
                <ResultInfo />
                <ResultAnalytics testId={testId as string} />
        </>
    );
}

export default ABResultPage;